// putting this here and adding to window so we can use it all over
// if this isn't the right/best way to do this, let's refactor it as appropriate
window.trackPageview = function(url) {
  tadaAnalyticsGaAllTrackers('set', 'page', url);
  tadaAnalyticsGaAllTrackers('send', 'pageview');
};
